import { Alert, Button, Card, Loading } from '@avrahami/ui';
import { useQuery } from '@tanstack/react-query';
import { Navigate } from '@tanstack/react-router';
import { sessionQuery } from '../api/session';
import { Centered, useLogout, useSwitchTenant } from '../components/Layout';
import { he } from '../i18n/he';
import { errorMessage } from '../lib/forms';

/**
 * Signed in without an active store: either the person belongs to no store (platform staff, or a
 * removed member), or they have stores and must pick one.
 */
export function NoStorePage() {
  const session = useQuery(sessionQuery);
  const logout = useLogout();
  const switchTenant = useSwitchTenant();

  if (session.isPending) {
    return (
      <Centered>
        <Loading />
      </Centered>
    );
  }
  if (session.data?.kind !== 'signed-in') return <Navigate to="/login" search={{}} />;
  const { me } = session.data;
  if (me.activeTenant !== null) return <Navigate to="/" />;

  return (
    <Centered>
      <Card title={he.noStore.title}>
        <div className="flex flex-col gap-4">
          {me.memberships.length === 0 ? (
            <p className="text-sm text-slate-700">{he.noStore.body}</p>
          ) : (
            <>
              <p className="text-sm text-slate-700">{he.noStore.choose}</p>
              <ul className="flex flex-col gap-2">
                {me.memberships.map((membership) => (
                  <li key={membership.tenantId} className="flex items-center justify-between gap-2">
                    <span>
                      {membership.displayName}{' '}
                      <span className="text-xs text-slate-500">{he.roles[membership.role]}</span>
                    </span>
                    <Button
                      busy={
                        switchTenant.isPending && switchTenant.variables === membership.tenantId
                      }
                      // One switch at a time: the other stores wait while it runs.
                      disabled={switchTenant.isPending}
                      onClick={() => {
                        switchTenant.mutate(membership.tenantId);
                      }}
                    >
                      {he.noStore.enter}
                    </Button>
                  </li>
                ))}
              </ul>
              {switchTenant.isError ? <Alert>{errorMessage(switchTenant.error)}</Alert> : null}
            </>
          )}
          <Button
            tone="secondary"
            busy={logout.isPending}
            onClick={() => {
              logout.mutate();
            }}
          >
            {he.nav.logout}
          </Button>
        </div>
      </Card>
    </Centered>
  );
}
